/**
 * Currencies list, can be interal object
 */
const currencies = {
    'USD': '$',
    'EUR': '€'
}

/**
 * Get curreny symbol
 * @param {string} currency
 */
export const toCurrencySymbol = (currency) => currencies[currency]

/**
 * Get total gold according price selected
 * @param {string} currentPrice
 * @param {object} prices
 * @param {number} goldRate
 * @param {number} multipliedBy
 */
export const toGoldPrice = (currentPrice, prices, goldRate, multipliedBy) => ((
    prices[currentPrice] *
    goldRate *
    multipliedBy
))

/**
 * Get total silver according price selected
 * @param {string} currentPrice
 * @param {object} prices
 * @param {number} goldRate
 * @param {number} multipliedBy
 */
export const toSilverPrice = (currentPrice, prices, silverRate, multipliedBy) => ((
    prices[currentPrice] *
    silverRate *
    multipliedBy
))
